import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, ViewEncapsulation} from '@angular/core';
import {DemoService} from '../../../demo.service';

// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

// import {CurrentsDataSourceComponent} from '../../../../views/appviews/currents-data-source/currents-data-source.component';
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule, NgForm, FormGroup, NgControl, NgModel } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import { Subscription } from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SystemFile } from './../../..//shared/models/file.model';
import { SubjectCommunicationAttatchments } from './../../../shared/models/subjectCommunicationAttachments.model';
import { SubjectCommunication } from './../../../shared/models/subjectCommunication.model';
import { Location } from '@angular/common';
import { HotToastService } from '@ngneat/hot-toast';
import { DataStateChangeEventArgs, FilterService, FilterSettingsModel, GridComponent, GroupSettingsModel, IFilter, IFilterUI, PageService, PdfExportService, RowDataBoundEventArgs, SelectionSettingsModel, SortService, TextWrapSettingsModel, ToolbarItems, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { TabsetComponent } from 'ngx-bootstrap';
import { Brand } from 'src/app/api/brand';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DataManager, DataUtil } from '@syncfusion/ej2-data';
import { DataService } from '../data.service';


import * as moment from 'moment';
// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';

@Component({
  selector: 'app-system-log-widget',
  templateUrl: './system-log-widget.component.html',
  styleUrls: ['./system-log-widget.component.scss'],
  providers: [DataService, ToolbarService, PdfExportService, PageService, FilterService, SortService]
})
export class SystemLogWidgetComponent implements OnInit {

// setup as observable?
@Input() item_id?; // impliments on changes.
@Input() item_data?; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size? = 'side'; // side | abstract | full

// Log Search Model Passed Varaibales
@Input() subject_id?; // impliments on changes.
@Input() job_id?; // impliments on changes.
@Input() log_type_id?; // impliments on changes.
@Input() brand_id?; // impliments on changes.
@Input() brand_type_id?; // impliments on changes.
@Input() user_id?; // impliments on changes.
@Input() user_level?; // impliments on changes.
@Input() limit?; // impliments on changes.
@Input() assigned_to_agents?; // impliments on changes.
@Input() suot_agent_id?; // impliments on changes.


  public wrapSettings: TextWrapSettingsModel; // { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both
  public datePickerObj: DatePicker;
  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
    // TABS sets the selected
    @ViewChild('staticTabs') staticTabs!: TabsetComponent;
    selected_tab?: number;
 
  // public logs$: Observable<SystemLog[]>;
  // Normal Layout
  logs$: Observable<any>;
  logs: any;

  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  searchOptions: {};
  initialPage: { pageSize: number; };
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  live_IP_Access_log_data: any;
  formatOptions: { type: string; format: string; };
  logs_search: Object;

  combo_model: Brand;
  search_model: SystemLog;
  brands_client: any;
  brands_agent: any;
  users: Object;
  brand_types: any;
  user_levels: any;
  system_log_types: any;

  
  @ViewChild('grid2')
  public grid2: GridComponent;
  // Need to create a different type of data service?
  // see: https://ej2.syncfusion.com/angular/documentation/grid/observables/
  public dataStateChange(state: DataStateChangeEventArgs): void {
    this.service.execute(state);
  }

// ... additions for datepicker column for sycfusion grid
  //public data: Object[];
  //public ddldata: Object[];
  //public pageOptions: Object;
  public category: string[];
  //public templateOptionsDate: IFilterUI;
  //public elem1: HTMLElement;
  //public datePickerObj: DatePicker;

  // maps the appropriate column to fields property
// public fields: Object = { text: 'Game', value: 'Id' };
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  DialogObj: any;

  // My Custom Logger Class.PHP - Same as BackVault.
  private _jsonURL_slim_api = 'https://api.sharmans.net.au/slimapp/public/' + 'live_IP_Access_log.txt';

  
  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    public service: DataService,
    private route: ActivatedRoute,
    vcr: ViewContainerRef,
    private router: Router,
    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService, 
    private modalService: BsModalService,
    private _location: Location,
    public sanitizer: DomSanitizer,
    public gfunc: GlobalFunctionsService,
    public toastr: HotToastService,
    
  ) {

   // Setup Grid
    // , {
      // text: 'TRY ME!',
      // tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Clic2k'
    // }
    this.toolbarOptions = ['ExcelExport', 'Search'];
    // this.toolbar = [
    // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

  //  this.initialPage = { pageSize: 100 };
    this.filterOptions = {
      type: 'Menu'
    };
    this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
    // this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
    // this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
    // this.dateFormat = 'dd/MM/yyyy';
     this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };


    this.initialPage = { pageSize: 100 };
    this.filterOptions = {
    type: 'Menu'
    };

    // this.groupOptions = { columns: ['id'] }; // sets auto grouping for the grid
    this.groupOptions = { }; // sets auto grouping for the grid

    this.formatoptions = {type: 'date', format: 'dd/MM/yyyy'};
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    // this.filter = { params: { format: this.dateFormat } };
    // this.sortOptions = { columns: [ ] };

    //checkbox selection options
    this.selectionOptions = {type: 'Multiple', checkboxOnly: true,}; // type: 'Multiple', mode: 'Both // checkboxMode: 'ResetOnRowClick'
    // this.selectionOptions = { type: 'Multiple', mode: 'Both'}; // 

    
    this.wrapSettings = { wrapMode: 'Content' };
    this.searchOptions = {  };

   }

   ngOnChanges(changes) {

// we need to save the agent ID  and suot_id to get easily from the data to search for agent... specific history.

// _if log_content[0].suot_agent_id == the current passed agent ID

    let passed_search_model = {
      log_type_id: this.log_type_id,
      limit: this.limit,
      subject_id: this.subject_id
    }

  
// Need to filter this array... I think its time for that JSON in the email
this.getLogsSearch(passed_search_model)
if(this.suot_agent_id){
            //   // this.toastr.info(' Agent Filter Required ' + this.suot_agent_id)
            // // filter the log_content.allocated_agent_array.brand_id = ssuot_agent_id. // this is the rult fr subjects urgent passeed information. // make widget size and view only for this 

            // // lets do loadash filtering the array of arrays.
            // //loadash

            // // Original array 
            // let users = [
            //   {
            //       'user': 'luv',
            //       'salary': 36000,
            //       'active': true
            //   },
            //   {
            //       'user': 'kush',
            //       'salary': 40000,
            //       'active': false
            //   }
            // ];

            // // Using the _.filter() method
            // // let filtered_array = _.filter(
            // //   users, function (o) {
            // //       return !o.active;
            // //   }
            // // );

            // let log_content = DataUtil.parse.parseJson(this.logs_search[0].log_content) // need to pass the content first befoer I can filter etc
            // // console.log('Log content:' + JSON.stringify(log_content))
            // let assigned_to_agents = log_content[0].assigned_to_agents
            // console.log('assigned_to_agents:' + JSON.stringify(assigned_to_agents))

            // // let filtered_array = _.filter(
            // //   assigned_to_agents, function (o) {
            // //       return o.recipient_brand_id === this.suot_agent_id;
            // //   }
            // // );

            // // // Printing the output 
            // // console.log(filtered_array);
            // // // logs_search

 } 

    if (changes.item_id) {

    }
  }


  ngOnInit(): void {


  }



  public getLogsSearch(search_model) {
    // this.logs_search = [];
    this._demoService.fetchSystemLogSearch(search_model)
    .pipe(
      this.toastr.observe({
        loading: 'Checking...',
        success: '🚀',
        error: '...😡...'
     })
     )
    .subscribe(
      (res) => (
        this.logs_search = res,
        this.grid2.refresh()
        ),
      (err) => console.error(err.status)
    );
  } /* */



// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      // this.grid.excelExport();
      this.grid2.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid2.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.logs }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}


subjectEditLink(subject_id) {
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  this.gfunc.globalJobSubjectView(subject_id);
}


  
refreshGrid(){ // refresh the databutton
  // this.getLogs();
  // this.grid.refresh();
};


  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
    this.selected_tab = tab_id; // so that we can load the queries only when the tabs clicked
  };


// Get API Logs
public getJSON(): Observable<any> {
  return this.http.get(this._jsonURL_slim_api);
}





// grid search buttons
searchGridColStatus(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['status'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}



searchGridColCreatedVia(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['created_via'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}


searchGridRemaining(string) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['status'], operator: 'contains', key: 'processing', ignoreCase: true };
  // now refresh the grid
  this.grid2.refresh();
}

searchGridColTotalAbove(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['total'], operator: 'greaterThanOrEqual', key: 65, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}



searchGridMail(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['shipping_total'], operator: 'lessThanOrEqual ', key: .01, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}


searchGridCP(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid2.search(searchText);

  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['shipping_total'], operator: 'greaterThanOrEqual ', key: 1, ignoreCase: true };
  // now refresh the grid2
  this.grid2.refresh();
}

clearSearchGrid() {
  this.grid2.searchSettings.key = '';
}

searchGrid(name) {
  this.searchOptions = {  };
  this.grid2.searchSettings.key = '';
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  const searchText: string = name;
  this.grid2.search(searchText);

}


clickHandlerRIS() {
  this.grid2.enablePersistence = false;
  window.localStorage.setItem("gridGrid", "");
  this.grid2.destroy();
  //reloads the page
  location.reload();
}








}
